import { useNavigate, useParams } from "react-router-dom";
import Logo from "./Logo";
import PasswordForm from "./PasswordForm";
import { saveSession, sessionFromAccount } from "../data/session";

const base = process.env.REACT_APP_BACKEND_URL || "";

const PasswordReset = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const submit = async (password) => {
    try {
      const response = await fetch(`${base}/api/auth/password/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) return data.detail || "Ce lien a expiré.";
      saveSession(sessionFromAccount(data, data.token));
      navigate("/", { replace: true });
      return "";
    } catch {
      return "Le serveur ne répond pas.";
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm">
        <Logo />
        <PasswordForm
          testId="reset-form"
          title="Nouveau mot de passe"
          intro="Choisissez un nouveau mot de passe. Vos autres sessions seront fermées."
          submitLabel="Enregistrer et me connecter"
          onSubmit={submit}
        />
      </div>
    </div>
  );
};

export default PasswordReset;
